import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";

// Message de confidentialité simple et rassurant (sans promesse technique excessive).
export default function PrivacyNote({ className = "", text }) {
  const { t } = useTranslation();
  return (
    <div data-testid="privacy-note"
      className={"flex items-start gap-2 text-xs rounded-xl px-3 py-2 " + className}
      style={{ background: "color-mix(in srgb, var(--accent) 8%, transparent)",
               color: "color-mix(in srgb, var(--text-main) 72%, transparent)" }}>
      <Lock size={14} className="mt-0.5 shrink-0" />
      <span>{text || t("privacy.default")}</span>
    </div>
  );
}
